import React from 'react';

export default ({message}) => <div className="alert alert-danger" role="alert">{message}</div> 